import React from 'react';
import NavBar from './NavBar';
import UserNameContext from "./UserNameContext";
import EnvContext from "./envContext";
import AtsgHomePage from "./pages/AtsgHomePage"
import XioSupportToolPage from "./pages/XioSupportToolPage";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const location = useLocation();
  const { accounts} = useMsal();
  // Extract the user's name from the ID token claims
  const userName = accounts[0]?.name || "User";

  // Check if we're on the landing page
  const isLandingPage = location.pathname === '/';

  let ENV = '';
  if(process.env.REACT_APP_RUN_ENV === 'local') {
    ENV='HQE';
  } else if (process.env.REACT_APP_RUN_ENV === 'qe') {
    ENV='HQE'
  } else {
    ENV='PRD';
  } 

  return (
    <>
      {/* Pass authentication info to NavBar */}
      <EnvContext.Provider value= {ENV} >
      <UserNameContext.Provider value= {userName} >
      {/* Only show NavBar if not on landing page */}
      {!isLandingPage && <NavBar/>}
      <div style={{ marginTop: isLandingPage ? '0px' : '60px' }}> {/* Add margin to avoid overlap, except on landing page */}
        {children}
      </div>
      </UserNameContext.Provider>  
      </EnvContext.Provider>
    </>
  );
};

export default Layout
